import React from "react";
import "../../../css/Grupo3/G3Landing.css";
import Componente5 from "../../../Component/Grupo3/Componente5";

function Vista5() {
  return (
    <div className="wrapper">
      <Componente5 />
    </div>
  );
}

export default Vista5;
